import type { ColorKeys } from '../../styles/colors'
import { getColor } from '../../styles/colors'

function Link( { color = 'white' as ColorKeys, title = 'Link' } ) {
  const theColor = getColor( color )

  return (
    <svg 
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{ title }</title>
      <path 
        d="M3.77051 10.8399L1.1405 13.4699L0.0205078 12.3499L2.65051 9.71993L3.77051 10.8399ZM0.340508 11.3599C-0.209493 10.2699 -0.0394958 8.89993 0.860504 7.99993L2.05051 6.80993C2.62051 6.23993 3.36051 5.96993 4.10051 5.96993C4.55051 5.96993 5.00051 6.06993 5.41051 6.28993L3.71051 7.97993C3.62051 8.01993 3.35051 7.90993 3.24051 8.00993L2.05051 9.19993C1.96051 9.29993 2.06051 9.55993 2.02051 9.66993L0.330505 11.3699L0.340508 11.3599ZM7.2205 8.06993C7.7705 9.15993 7.5805 10.5099 6.6805 11.4299L5.49051 12.6199C4.92051 13.1899 4.18051 13.4599 3.44051 13.4599C2.99051 13.4599 2.55051 13.3599 2.13051 13.1399L3.83051 11.4499C3.93051 11.4099 4.19051 11.5099 4.30051 11.4199L5.49051 10.2299C5.59051 10.1299 5.48051 9.84993 5.52051 9.75993L7.2205 8.05993V8.06993ZM8.1705 4.19993L9.29051 5.31993L4.76051 9.82993L3.65051 8.71993L8.16051 4.18993L8.1705 4.19993ZM5.84051 5.83993C5.29051 4.74993 5.46051 3.39993 6.38051 2.47993L7.5705 1.28993C8.1405 0.719932 8.88051 0.429932 9.62051 0.429932C10.0705 0.429932 10.5105 0.549932 10.9305 0.759932L9.2305 2.44993C9.1305 2.48993 8.87051 2.38993 8.76051 2.47993L7.5705 3.66993C7.4705 3.76993 7.5805 4.04993 7.5405 4.14993L5.84051 5.83993ZM12.7205 2.56993C13.2705 3.64993 13.1005 5.00993 12.2005 5.91993L11.0105 7.10993C10.4405 7.67993 9.70051 7.94993 8.96051 7.94993C8.51051 7.94993 8.0605 7.84993 7.65051 7.63993L9.3405 5.93993C9.4405 5.89993 9.72051 6.00993 9.82051 5.90993L11.0105 4.71993C11.1005 4.61993 11.0005 4.35993 11.0405 4.24993L12.7305 2.55993L12.7205 2.56993ZM9.30051 3.05993L11.9305 0.429932L13.0505 1.54993L10.4205 4.17993L9.30051 3.05993Z"
        fill={ theColor }
      />
    </svg>
  )
}

export default Link
